import Product from "../../views/pages/Product.vue";
export default [
  {
    path: "/product/:slug",
    name: "ProductInfo",
    component: Product
  }
];
